import { Cookies } from '../../../../utility/cookies';
import { HYBRIS_ROUTE_COOKIE } from './cookieKeys';

const hybrisRoute = {
    get: () => Cookies.read(HYBRIS_ROUTE_COOKIE),
    add: (routeCookie: string) => {
        Cookies.create(HYBRIS_ROUTE_COOKIE, routeCookie);
    },
};

export default hybrisRoute;
